<template>
    <div class="ola-footer-wrapper">
        <div class="ola-inner-wrapper">
            <div class="ola-footer-content">
                <div class="ola-footer-serve">
                    <h3 class="ola-footer-title">客服电话</h3>
                    <h2 class="ola-footer-tel">400-808-1648</h2>
                    <p>{{customerService.serviceTime}}</p>
                    <ola-button size="lg" round class="kf-consult-btn" @pointerdown="preloadCustomerService" @click="openCustomerService" data-buriedname="footer_kf" data-buriedvalue="footer_kf"><i class="iconfont">&#xe6a4;</i>在线客服</ola-button>
                </div>
                <div class="ola-footer-link-item second">
                    <h3 class="ola-footer-title">公司信息</h3>
                    <div class="ola-footer-link-content second" v-if="footerLinks && footerLinks.length > 0">
                        <template v-for="(link, index) in footerLinks" :key="index">
                            <a :href="link.url" target="_blank">{{ link.name }}</a>
                        </template>
                    </div>
                </div>
                <div class="ola-footer-link-item last attention-item">
                    <h3 class="ola-footer-title last">关注我们</h3>
                    <ul class="ola-footer-link-content last">
                        <li>
                            <i class="iconfont">&#xe600;</i>
                            <div class="lang-name">欧那多语种</div>
                            <div class="ola-q-code">
                                <img :src="getRootImagePath('footer-qcode/moreLaguage-qcode.png')" alt="">
                            </div>
                        </li>
                        <li>
                            <i class="iconfont">&#xe600;</i>
                            <div class="lang-name">欧那法语</div>
                            <div class="ola-q-code">
                                <img :src="getRootImagePath('footer-qcode/fr-qcode.png')" alt="">
                            </div>
                        </li>
                        <li>
                            <i class="iconfont">&#xe600;</i>
                            <div class="lang-name">欧那德语</div>
                            <div class="ola-q-code">
                                <img :src="getRootImagePath('footer-qcode/de-qcode.png')" alt="">
                            </div>
                        </li>
                        <li>
                            <i class="iconfont">&#xe600;</i>
                            <div class="lang-name">欧那俄语</div>
                            <div class="ola-q-code">
                                <img :src="getRootImagePath('footer-qcode/ru-qcode.png')" alt="">
                            </div>
                        </li>
                        <li>
                            <i class="iconfont">&#xe600;</i>
                            <div class="lang-name">欧那西语</div>
                            <div class="ola-q-code">
                                <img :src="getRootImagePath('footer-qcode/es-qcode.png')" alt="">
                            </div>
                        </li>
                        <li>
                            <i class="iconfont">&#xe600;</i>
                            <div class="lang-name">欧那葡语</div>
                            <div class="ola-q-code">
                                <img :src="getRootImagePath('footer-qcode/pt-qcode.png')" alt="">
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="ol-friendship-link" v-if="friendlyLinks && friendlyLinks.length > 0">
            <div class="ola-inner-wrapper">
                <div class="links-cont">
                    友情链接：
                    <template v-for="(link, index) in friendlyLinks" :key="index">
                        <a :href="link.url" target="_blank">{{ link.name }}</a>
                        <span v-if="index < friendlyLinks.length - 1"> | </span>
                    </template>
                </div>
            </div>
        </div>
        <div class="footer-copyright">
            <p class="copy-right-inf">
                <a class="ola-footer-ga-icon"
                    href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010702006725"
                    target="_blank"><i></i>沪公网安备 31010702006725号</a>
                | <a href="http://beian.miit.gov.cn">沪ICP备13040679号-2</a> | Copyright @ 2013 olacio.com All Rights
                Reserved 上海云兜网络科技有限公司 版权所有
                | <a href="/teaching-license" target="_blank">教师信息公示</a>
            </p>
            <p>
                <img src="https://static.olacio.com/img/sgs.jpg">
                <img src="https://static.olacio.com/img/shpolice.jpg">
                <img src="https://static.olacio.com/img/alipay_trust.jpg">
            </p>
        </div>
    </div>
</template>
<script>
import { inject } from 'vue';
import { getRootImagePath } from '@/utils/ImageHelper';
import { openCustomerService, preloadCustomerService } from '@/utils/CustomerService';

export default {
    setup() {
        // 注入站点配置
        const siteConfig = inject('siteConfig');

        // 获取友情链接
        const friendlyLinks = siteConfig?.friendlyLinks || [];
        const footerLinks = siteConfig?.footerLinks || [];
        const customerService = siteConfig?.customerService || {};

        // 获取静态图片URL
        const getStaticImageUrl = (filename) => {
            // 如果在生产环境下使用CDN，直接返回CDN路径
            if (typeof __ENV__ !== 'undefined' && __ENV__ === 'production') {
                return `https://static.olacio.com/img/${filename}`;
            }
            // 开发环境使用本地路径
            return getRootImagePath(`static/${filename}`);
        };

        return {
            friendlyLinks,
            getRootImagePath,
            footerLinks,
            customerService,
            getStaticImageUrl,
            openCustomerService,
            preloadCustomerService
        };
    }
}
</script>
<style scoped lang="scss">
@use "@/assets/styles/common/responsive" as responsive;

.ola-footer-wrapper {
    padding: 46px 0 32px 0;
    min-width: 1200px;
    background: #2D2D2D;

    @include responsive.ola-respond-below(lg) {
        min-width: auto;
        padding-left: 0;
    }

    @include responsive.ola-respond-below(md) {
        min-width: auto;
        padding-left: 0;
        padding: 30px 0 20px;
    }
    @include responsive.ola-respond-below(sm) {
        .attention-item {
            display: none;
        }
    }

    .ola-inner-wrapper {
        @include responsive.ola-respond-below(lg) {
            padding: 0 40px;
            min-width: auto;
            width: 900px;
        }

        @include responsive.ola-respond-below(md) {
            padding: 0 20px;
            width: 100%;
            margin: 0;
        }
    }

    .ola-footer-content {
        display: flex;
        justify-content: space-between;
        color: #fff;

        @include responsive.ola-respond-below(md) {
            flex-direction: column;
            justify-content: flex-start;
        }

        .ola-footer-serve {
            margin-right: 169px;
            .ola-btn-primary {
                background-color: #FB4643;
                border-color:#FB4643;
            }
            @include responsive.ola-respond-below(md) {
                margin-right: 0;
                margin-bottom: 40px;
                text-align: center;
            }
        }

        .ola-footer-link-item {
            &.second {
                @include responsive.ola-respond-below(sm) {
                    width: 100%;
                    margin-bottom: 40px;
                }
            }

            &.last {
                @include responsive.ola-respond-below(sm) {
                    padding: 0;
                }

                .ola-footer-link-content {
                    @include responsive.ola-respond-below(md) {
                        width: 100%;
                        justify-content: flex-start;

                        li {
                            width: 33.33%;
                            margin-bottom: 20px;
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                        }
                    }
                }
            }
        }

        .ola-btn-round {
            width: 147px;
            height: 40px;

            .iconfont {
                margin-right: 5px;
            }
        }

        .ola-footer-title {
            position: relative;
            font-size: 16px;
            padding: 5px 10px 5px 0;
            margin-bottom: 20px;
            font-weight: 400;
            @include responsive.ola-respond-below(md) {
                   text-align: center;
                   padding-bottom: 10px;
             }

            &::after {
                content: '';
                position: absolute;
                bottom: 0;
                left: 0;
                width: 32px;
                height: 3px;
                background: #FB4643;
                @include responsive.ola-respond-below(md) {
                   height: 1px;
                   width: 100%;
                   background-color: #666;
                }
            }
        }

        .ola-footer-tel {
            font-size: 30px;
            font-weight: 500;
        }

        p {
            margin-bottom: 24px;
            font-size: 14px;
            color: #999;
        }

        .ola-footer-link-content {
            display: flex;
            flex-wrap: wrap;

            &.second {
                width: 289px;
                line-height: 27px;

                @include responsive.ola-respond-below(md) {
                    width: 100%;
                    display: flex;
                    flex-wrap: wrap;
                    text-align: center;
                    justify-content: flex-start;
                }

                a {
                    @include responsive.ola-respond-below(sm) {
                        width: 33%;
                        box-sizing: border-box;
                        padding-right: 10px;
                    }
                }

                a:last-child {
                    @include responsive.ola-respond-below(sm) {
                        width: 33%;
                    }
                }
            }

            &.last {
                width: 330px;

                @include responsive.ola-respond-below(sm) {
                    width: 100%;
                }

                .ola-q-code {
                    width: 155px;
                    position: absolute;
                    top: -162px;
                    left: -65px;
                    display: none;
                    
                    @include responsive.ola-respond-below(md) {
                        top: -180px;
                        left: 50%;
                        transform: translateX(-50%);
                    }
                }

                li {
                    margin-bottom: 0.2rem;
                    width: 100px;
                    position: relative;
                    color: #999;
                    cursor: default;

                    .iconfont {
                        font-size: 36px;
                    }

                    &:hover {
                        .ola-q-code {
                            display: block;
                        }

                        color: #fff;
                    }
                }
            }

            a {
                margin-bottom: 5px;
                color: #999;
                display: block;
                width: 100px;

                @include responsive.ola-respond-below(md) {
                    width: 33%;
                }

                &:hover {
                    color: #fff;
                }
            }
        }
    }

    .ol-friendship-link {
        margin-top: 32px;
        padding-top: 32px;
        margin-bottom: 30px;
        font-size: 12px;
        border-top: 1px solid #555;
        color: rgba(153, 153, 153, 0.40);
        text-align: center;

        @include responsive.ola-respond-below(md) {
            margin-top: 20px;
            padding-top: 20px;
            margin-bottom: 20px;
            padding: 20px 20px 0;
        }

        a {
            color: rgba(153, 153, 153, 0.40);
        }
        
        .links-cont {
            @include responsive.ola-respond-below(md) {
                line-height: 24px;
            }
        }
    }

    .footer-copyright {
        text-align: center;
        font-size: 12px;

        @include responsive.ola-respond-below(md) {
            padding: 0 20px;
        }

        .copy-right-inf {
            padding: 0 10px;
            margin-bottom: 30px;
            
            @include responsive.ola-respond-below(md) {
                line-height: 24px;
            }
        }

        color: rgba(153, 153, 153, 0.40);

        a {
            color: rgba(153, 153, 153, 0.40);
        }

        p {
            img {
                margin-right: 20px;
                
                @include responsive.ola-respond-below(md) {
                    margin: 5px 10px;
                    height: 30px;
                }
            }

            .copy-right-inf {
                margin-bottom: 35px;
            }
        }
    }
}
</style>